

import React, { useEffect, useState } from "react"
import {
  Button,
  Input,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Image,
  Alert,
  User,
  Avatar,
} from "@heroui/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCode, faCommentDots, faEllipsis, faEye, faEyeSlash, faGem, faIdBadge, faInfo, faUnlock, faUser } from "@fortawesome/free-solid-svg-icons"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { toast, ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css" //react toastify css

import { linksUrl } from "../constants/enum.js"
import { setLogin } from "../state/authSlice.jsx"
import { usePostLogin } from "../api/reactQueryCustomHooks.jsx"
import { useQueryClient } from "@tanstack/react-query"
import { resetCompCode } from "../state/companySlice.jsx"
import { isMobile } from "react-device-detect"


export default function App() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const [isVisible, setIsVisible] = useState(false)
  const toggleVisibility = () => setIsVisible(!isVisible)


  const [formData, setFormData] = useState({
    clientCode: "",
    loginName: "",
    password: "",
  })

  const [errors, setErrors] = useState({})

  const resetValues = () => {
    setFormData({
      clientCode: "",
      loginName: "",
      password: "",
    })
  }

  const onSuccessTasks = (data) => {

    if (data && Object.keys(data)?.length > 0) {
      navigate(linksUrl.companies)
      dispatch(
        setLogin({
          user: data.user,
          token: data.accessToken,
          menu: { appMenu: data.appMenu, userMenu: data.userMenu },
          isAuthenticated: true,
          userSetting: data.userSetting
        })
      )
      dispatch(resetCompCode())
      queryClient.removeQueries()
    }
    else {
      toast.error("Incorrect Details...", {
        "position": "top-center"
      })
    }


  }

  const { isPending, mutate: login } = usePostLogin({
    url: "/user/login",
    queryKey: "auth",
    resetValues,
    successMessage: "",
    onSuccessTasks,
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }

  const validateForm = () => {
    let msg = ''
    if (formData.clientCode.trim() === "") {
      msg = " Client Code required , "
    }
    if (formData.loginName.trim() === "") {
      msg += " Login Name required , "
    }
    if (formData.password.trim() === "") {
      msg += " Password required , "
    }
    return msg
  }


  const handleSubmit = (e) => {
    e.preventDefault()
    let errorMsg = validateForm()


    if (errorMsg.trim() == "") {
      login({
        data: {
          Client_Code: formData.clientCode,
          LoginName: formData.loginName,
          Password: formData.password,
        },
      })
    }
    else {
      toast.error(errorMsg, { "position": "top-center" })
    }

  }

  return (
    <div>
      <ToastContainer />
      {/* //bg-gradient-to-tr from-gray-50 to-white */}
      <div
        className={`
    min-h-screen
    w-full
    px-4
    ${isMobile
            ? "bg-gradient-to-br from-gray-50 via-white to-cyan-50 pt-10"
            //? "bg-gradient-to-br from-white via-cyan-50 to-blue-50 pt-8"
            : "bg-gradient-to-br from-gray-50 via-white to-cyan-50 pt-10"
          }
  `}
      >
        <div className="flex w-full flex-col items-center">


          {/* Diamond Logo */}
          {/* Diamond Logo with Effects */}
          {/* Diamond Logo */}
          <div className="relative mb-2">

            {/* Soft Glow */}
            <div
              className="
      absolute
      inset-0
      rounded-full
      bg-indigo-300/30
      blur-2xl
    "
            />

            {/* Static Diamond Circle */}
            <div
              className="
      relative
      flex
      h-20
      w-20
      items-end
      justify-center
      overflow-hidden
      rounded-full
      border
      border-white
      bg-gradient-to-br
      from-white
      via-indigo-50
      to-blue-100
      shadow-[0_0_30px_rgba(99,102,241,0.25)]
      ring-4
      ring-indigo-100
    "
            >
              {/* Light Reflection */}
              <div
                className="
        absolute
        top-2
        left-3
        h-6
        w-2
        rotate-12
        rounded-full
        bg-white/70
        blur-sm
      "
              />

              {/* Diamond Icon (only this blinks) */}
              <FontAwesomeIcon
                icon={faGem}
                className="
        relative
        z-10
        text-5xl
        text-indigo-500
        drop-shadow-[0_0_12px_rgba(99,102,241,0.6)]
     
     
      "
              />
            </div>

            {/* Sparkle Top Right */}
            <span
              className="
      absolute
      top-1
      right-1
      text-white
      text-md
      animate-ping
        [animation-delay:1200ms]
    "
            >
              ✦
            </span>

            {/* Sparkle Bottom Left */}
            <span
              className="
      absolute
      bottom-2
      left-0
      text-white
      text-xl
      animate-ping
      
    "
            >
            ✦
            {/* //  ✧ */}
            </span>

            {/* Sparkle Left Top */}
            <span
              className="
      absolute
      -top-1
      left-5
      text-yellow-500
      text-[15px]
      animate-pulse
     
    "
            >
              ✦
            </span>

          </div>



          {/* Login Card */}
          <div
            className={`
        w-full
        max-w-md
        rounded-2xl
        px-6
        py-8
        shadow-xl
        backdrop-blur-md
        ${isMobile
                ? "border-0 bg-white/90"
                : "border border-indigo-100 bg-white/90"
              }
      `}
          >


            {/* Header */}
            <div className="mb-8 flex flex-col items-center">

              <User
                description={
                  <h1
                    className="
                mt-4
                text-center
                text-2xl
                font-bold
                tracking-[0.3em]
                text-slate-600
              "
                  >
                    LOGIN
                  </h1>
                }
                avatarProps={{
                  src: "IITS_Logo.png",
                  size: "lg",
                  radius: "full",
                  isBordered: true,
                  className: "border-cyan-400"
                }}
              />

            </div>



            <form
              onSubmit={handleSubmit}
              autoComplete="off"
            >

              <div className="space-y-5">

                <div className="pb-5">
                  {/* Client Code */}
                  <Input
                    isRequired
                    type="text"
                    label="Client Code"
                    placeholder="Enter client code"
                    labelPlacement="outside"
                    name="clientCode"
                    value={formData.clientCode}
                    onChange={handleChange}
                    variant="bordered"
                    radius="lg"
                    size="md"
                    isDisabled={isPending}
                    startContent={
                      <FontAwesomeIcon
                        className="text-gray-400"
                        icon={faIdBadge}
                      />
                    }
                    classNames={{
                      label:
                        "text-xs font-semibold uppercase text-gray-600",
                      inputWrapper:
                        "bg-white border-gray-300 hover:border-cyan-400 focus-within:border-cyan-500"
                    }}
                  />

                </div>
                <div className="pb-5">

                  {/* Login Name */}
                  <Input
                    isRequired
                    type="text"
                    label="Login Name"
                    placeholder="Enter login name"
                    labelPlacement="outside"
                    name="loginName"
                    value={formData.loginName}
                    onChange={handleChange}
                    variant="bordered"
                    radius="lg"
                    size="md"
                    isDisabled={isPending}
                    startContent={
                      <FontAwesomeIcon
                        className="text-gray-400"
                        icon={faUser}
                      />
                    }
                    classNames={{
                      label:
                        "text-xs font-semibold uppercase text-gray-600",
                      inputWrapper:
                        "bg-white border-gray-300 hover:border-cyan-400 focus-within:border-cyan-500"
                    }}
                  />

                </div>

                {/* Password */}
                <Input
                  isRequired
                  label="Password"
                  placeholder="Enter password"
                  labelPlacement="outside"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  variant="bordered"
                  radius="lg"
                  size="md"
                  isDisabled={isPending}
                  type={isVisible ? "text" : "password"}
                  startContent={
                    <FontAwesomeIcon
                      className="text-gray-400"
                      icon={faUnlock}
                    />
                  }
                  endContent={
                    <button
                      type="button"
                      className="
                  text-gray-400
                  transition
                  hover:text-cyan-600
                "
                      onClick={toggleVisibility}
                    >
                      <FontAwesomeIcon
                        icon={isVisible ? faEyeSlash : faEye}
                      />
                    </button>
                  }
                  classNames={{
                    label:
                      "text-xs font-semibold uppercase text-gray-600",
                    inputWrapper:
                      "bg-white border-gray-300 hover:border-cyan-400 focus-within:border-cyan-500"
                  }}
                />


              </div>



              {/* Login Button */}
              <Button
                type="submit"
                isLoading={isPending}
                radius="lg"
                className="
            mt-8
            w-full
            bg-gradient-to-r
            from-cyan-500
            via-blue-500
            to-indigo-600
            py-2
            text-sm
            font-bold
            uppercase
            tracking-widest
            text-white
            shadow-md
            transition
            hover:scale-[1.02]
            hover:shadow-lg
          "
              >
                Login
              </Button>


            </form>


          </div>

        </div>
      </div>
    </div>

  )
}
